/**
 * Removes all child nodes descendant of the provided node
 * @param node
 */
export function removeChildren(node = {}) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}

/**
 * Removes a given node
 * @param node
 */
export function removeNode(node) {
  node.parentNode.removeChild(node);
}

/**
 * Constructs an <option/> Element using the provided options object.
 * @param options
 * @returns {Element}
 */
export function createOption(options = {}) {
  const option = document.createElement('option');

  option.setAttribute('label', options.label || '');
  option.text = options.label || '';
  option.value = options.value || '';
  option.defaultSelected = Boolean(options.defaultSelected);
  option.disabled = Boolean(options.disabled);

  return option;
}

export function hasClass(el, className) {
  if (!el || !className) {
    return null;
  }

  if (el.classList) {
    return el.classList.contains(className);
  }

  return new RegExp(`(^|\\s)${className}($|\\s)`).test(el.className);
}
